import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldsSearchVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
}>;


export type ApiWorldsSearch = { search: { worlds: Array<{ name: string, id: number, imageUrl: string | null, slug: string, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } }> } };



export const ApiWorldsSearchDocument = /*#__PURE__*/ `
    query WorldsSearch($searchTerm: String!) {
  search: exhibitionsSearchDb(query: $searchTerm, perPage: 3, page: 0) {
    worlds: exhibitions {
      name
      id
      imageUrl
      slug
      curator {
        publicKey: accountAddress
        name
        profileImageUrl
        username
      }
    }
  }
}
    `;

export const useWorldsSearch = <
      TData = ApiWorldsSearch,
      TError = ClientError
    >(
      variables: ApiWorldsSearchVariables,
      options?: Omit<UseQueryOptions<ApiWorldsSearch, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldsSearch, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldsSearch, TError, TData>(
      {
    queryKey: ['WorldsSearch', variables],
    queryFn: apiFetcher<ApiWorldsSearch, ApiWorldsSearchVariables>(ApiWorldsSearchDocument, variables),
    ...options
  }
    )};

useWorldsSearch.getKey = (variables: ApiWorldsSearchVariables) => ['WorldsSearch', variables];

export const useInfiniteWorldsSearch = <
      TData = InfiniteData<ApiWorldsSearch>,
      TError = ClientError
    >(
      variables: ApiWorldsSearchVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldsSearch, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldsSearch, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldsSearch, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldsSearch.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldsSearch, ApiWorldsSearchVariables>(ApiWorldsSearchDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldsSearch.getKey = (variables: ApiWorldsSearchVariables) => ['WorldsSearch.infinite', variables];


useWorldsSearch.fetcher = (variables: ApiWorldsSearchVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldsSearch, ApiWorldsSearchVariables>(ApiWorldsSearchDocument, variables, options);
